export const PaymentMethodEnum = {
  pix: 'Pix',
  boleto: 'Boleto',
  credit_card: 'Cartão de crédito',
  boleto_pix: 'Bolepix',
  credit_card_recurring: 'Cartão Recorrente',
  credit_card_installments: 'Cartão Parcelado',
  cash: 'Dinheiro',
  other: 'Outros',
  transfer: 'Transferência (TED/DOC)',
  direct_payment: 'Recebimento manual'
}
